export const wizardSteps = [
  {
    canNavigate: true,
    completed: true,
    steps: 0,
    title: "BASIC DETAILS",
  },
  {
    canNavigate: true,
    completed: true,
    steps: 1,
    title: "PRE-AUTH",
  },
  {
    canNavigate: true,
    completed: true,
    steps: 2,
    title: "PRE-AUTH QUERY",
  },
  {
    canNavigate: true,
    completed: true,
    steps: 3,
    title: "ENHANCEMENT",
  },
  {
    canNavigate: true,
    completed: false,
    steps: 4,
    title: "DISCHARGE",
  },
  {
    canNavigate: true,
    completed: false,
    steps: 5,
    title: "CLAIM",
  },
  // {
  //   canNavigate: false,
  //   completed: false,
  //   steps: 6,
  //   title: "INVOICE & RECONCILIATION",
  // },
];

export const wizardStepsCghsOp = [
  {
    canNavigate: true,
    completed: true,
    steps: 0,
    title: "BASIC DETAILS",
  },
  {
    canNavigate: true,
    completed: true,
    steps: 1,
    title: "PRE-AUTH",
  },
  {
    canNavigate: false,
    completed: false,
    steps: 2,
    title: "CLAIM",
  },
];

export const wizardStepsCghsIp = [
  {
    canNavigate: true,
    completed: true,
    steps: 0,
    title: "BASIC DETAILS",
  },
  {
    canNavigate: true,
    completed: true,
    steps: 1,
    title: "PRE-AUTH",
  },
  {
    canNavigate: true,
    completed: true,
    steps: 2,
    title: "PRE-AUTH QUERY",
  },
  {
    canNavigate: true,
    completed: true,
    steps: 3,
    title: "ENHANCEMENT",
  },

  {
    canNavigate: true,
    completed: false,
    steps: 4,
    title: "DISCHARGE",
  },
  {
    canNavigate: false,
    completed: false,
    steps: 5,
    title: "CLAIM",
  },
];
export const wizardStepsStarHealth = [
  {
    canNavigate: true,
    completed: true,
    steps: 0,
    title: "BASIC DETAILS",
  },
  {
    canNavigate: true,
    completed: true,
    steps: 1,
    title: "PRE-AUTH",
  },
  // {
  //   canNavigate: true,
  //   completed: true,
  //   steps: 2,
  //   title: "PRE-AUTH QUERY",
  // },
  {
    canNavigate: true,
    completed: false,
    steps: 2,
    title: "DISCHARGE",
  },
  {
    canNavigate: false,
    completed: false,
    steps: 3,
    title: "CLAIM",
  },
];
export const wizardStepsEchs = [
  {
    canNavigate: true,
    completed: true,
    steps: 0,
    title: "BASIC DETAILS",
  },
  {
    canNavigate: true,
    completed: true,
    steps: 1,
    title: "PRE-AUTH",
  },
  {
    canNavigate: true,
    completed: true,
    steps: 2,
    title: "PRE-AUTH QUERY",
  },
  {
    canNavigate: true,
    completed: true,
    steps: 3,
    title: "ENHANCEMENT",
  },

  {
    canNavigate: true,
    completed: false,
    steps: 4,
    title: "DISCHARGE",
  },
  {
    canNavigate: false,
    completed: false,
    steps: 5,
    title: "CLAIM",
  },
];

export const wizardStepsEchsOp = [
  {
    canNavigate: true,
    completed: true,
    steps: 0,
    title: "BASIC DETAILS",
  },
  {
    canNavigate: true,
    completed: true,
    steps: 1,
    title: "PRE-AUTH",
  },
  {
    canNavigate: false,
    completed: false,
    steps: 2,
    title: "CLAIM",
  },
];
